import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { TopBar } from './top-bar';
import { TaskPanel } from '@/components/tasks/task-panel';
import { CreateProjectDialog } from '@/components/projects/CreateProjectDialog';
import { useUIStore } from '@/stores/ui-store';
import { cn } from '@/lib/utils';

export function AppLayout() {
  const { sidebarCollapsed, taskPanelOpen } = useUIStore();

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <CreateProjectDialog />

      <div
        className={cn(
          'flex flex-1 flex-col transition-all duration-300',
          sidebarCollapsed ? 'ml-16' : 'ml-72'
        )}
      >
        <TopBar />

        <main
          className={cn(
            'flex-1 overflow-auto transition-all duration-300 pl-4',
            taskPanelOpen && 'mr-96'
          )}
        >
          <Outlet />
        </main>
      </div>

      <TaskPanel />
    </div>
  );
}
